// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import MediaLifeSpan from '@/components/composite/Charts/composed/MediaLifeSpan';

export const postLifeSpanConfig = {
    margin: { left: -30, bottom: 15 },
    minWidth: 650,
    name: {
        time: 'time',
        value: 'current_post',
        previous_value: 'previous_post'
    },
    id: 'media_life_span',
    timeFormatter: (time) => time.replace(':', 'h'),
    valueFormat: classicFormat,
    color: {
        value: 'red',
        previous_value: 'gray'
    },
    tooltip: 'chart.linkedin.tooltip_post_life_span',
    size: SIZE_FULL,
    type: 'chart',
    defaultFilter: 'reactions',
    filters: {
        reactions: {
            title: 'chart.linkedin.post_life_span_reactions',
            menu: 'chart.linkedin.post_life_span_show_reactions'
        },
        comments: {
            title: 'chart.linkedin.post_life_span_comments',
            menu: 'chart.linkedin.post_life_span_show_comments'
        },
        clicks: {
            title: 'chart.linkedin.post_life_span_clicks',
            menu: 'chart.linkedin.post_life_span_show_clicks'
        },
        shares: {
            title: 'chart.linkedin.post_life_span_shares',
            menu: 'chart.linkedin.post_life_span_show_shares'
        },
        engagements: {
            title: 'chart.linkedin.post_life_span_engagement',
            menu: 'chart.linkedin.post_life_span_show_engagement'
        }
    },
    tooltipTranslation: {
        token: 'chart.instagram.media_life_span_tooltip_chart',
        values: ['time', 'value', 'previous_value']
    },
    element: MediaLifeSpan
};
